import React from "react";

const reviews = [
    {
        name: "Himanshu Chahar",
        quote: "Amit is an absolute gem of a buyer’s agent!",
        detail:
            "He made the entire process smooth, stress-free, and enjoyable. His deep market knowledge and genuine care for clients set him apart.",
    },
    {
        name: "Deepak Verma",
        quote: "An amazing experience from start to finish.",
        detail:
            "Amit guided me with professionalism and care. His honesty, attention to detail, and negotiation skills are unmatched.",
    },
    {
        name: "Amanuddin Nagthe",
        quote: "Exceptional and genuinely committed to client satisfaction.",
        detail:
            "Amit is friendly and made the entire buying journey enjoyable and stress free. Highly recommended.",
    },
    {
        name: "Binish S",
        quote: "Absolutely amazing working with Amit's team.",
        detail:
            "Always happy to answer questions — securing our IP was smooth thanks to his professionalism and integrity.",
    },
    {
        name: "Senthilnathan Mohanasundaram",
        quote: "Helped us buy three homes across Australia.",
        detail:
            "Super professional, got us fantastic deals. Couldn’t have asked for a better team to work with!",
    },
    {
        name: "Mohammad Shurfu-ud-doha",
        quote: "Extensive knowledge & smooth investment journey.",
        detail:
            "Amit was always available to support and advise. Looking forward to buying again with him!",
    },
];

const CustomerReviewsCarousel = () => {
    return (
        <section className="bg-[#f9f9f9] py-16 px-6">
            <div className="max-w-6xl mx-auto text-left">
                <h2 className="text-2xl font-bold text-[#003366] mb-6 text-center md:text-left">
                    What Our Customers Say
                </h2>


                {/* Carousel */}
                <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-4">
                    {reviews.map((r, i) => (
                        <div
                            key={i}
                            className="snap-start flex-shrink-0 w-full md:w-[30%] border border-gray-200 rounded-lg p-5 bg-white shadow-sm"
                        >
                            <div className="text-[#fbb40b] text-sm mb-1">★★★★★</div>
                            <p className="text-[#003366] font-semibold mb-2">“{r.quote}”</p>
                            <p className="text-sm text-gray-700 mb-3">{r.detail}</p>
                            <p className="text-sm text-gray-500">— {r.name}</p>
                        </div>
                    ))}
                </div>

                <a
                    href="https://g.co/kgs/AA963Jq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#da3e13] underline inline-block mt-4"
                >
                    View all reviews on Google
                </a>
            </div>
        </section>
    );
};

export default CustomerReviewsCarousel;
